// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"52":"c377de5274882a058ae2","65":"22017cc4c10450bd15e8","591":"66554330e28681faab81","876":"f661503fc9d0eb80778b"}[chunkId] + ".js";
};